import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGemini = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("mask", {
			id: "mask0_9544_298",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 16,
			height: 16,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M7.98695 0C8.15434 0 8.30031 0.114462 8.34117 0.276923C8.46604 0.773819 8.63059 1.25989 8.83323 1.73046C9.36295 2.96123 10.0898 4.0384 11.0127 4.96123C11.936 5.88431 13.0129 6.6112 14.2434 7.14092C14.7141 7.3435 15.2003 7.50805 15.6972 7.63298C15.8597 7.67385 15.9739 7.81957 15.9739 7.98695C15.9739 8.15434 15.8597 8.30031 15.697 8.34117C15.2001 8.46604 14.714 8.63059 14.2434 8.83323C13.0127 9.36295 11.9358 10.0898 11.0127 11.0127C10.0898 11.936 9.36295 13.0129 8.83323 14.2434C8.63056 14.7141 8.46593 15.2003 8.34092 15.6972C8.32114 15.7762 8.27558 15.8463 8.21146 15.8964C8.14734 15.9465 8.06833 15.9738 7.98695 15.9739C7.81957 15.9739 7.67385 15.8597 7.63298 15.697C7.50802 15.2001 7.34339 14.714 7.14068 14.2434C6.6112 13.0127 5.88455 11.9358 4.96123 11.0127C4.03815 10.0898 2.96123 9.36295 1.73046 8.83323C1.25987 8.63058 0.773805 8.46595 0.276923 8.34092C0.197979 8.3212 0.127873 8.27569 0.077712 8.21162C0.0275511 8.14755 0.00020297 8.06857 0 7.9872C0 7.81982 0.114462 7.67409 0.276923 7.63323C0.773826 7.50828 1.2599 7.34365 1.73046 7.14092C2.96123 6.61145 4.0384 5.88455 4.96123 4.96148C5.88431 4.03865 6.6112 2.96148 7.14092 1.73071C7.3435 1.26011 7.50804 0.774045 7.63298 0.277169C7.65267 0.198138 7.69819 0.127947 7.76232 0.0777335C7.82645 0.0275203 7.90551 0.000161972 7.98695 0Z",
				fill: "black"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M7.98695 0C8.15434 0 8.30031 0.114462 8.34117 0.276923C8.46604 0.773819 8.63059 1.25989 8.83323 1.73046C9.36295 2.96123 10.0898 4.0384 11.0127 4.96123C11.936 5.88431 13.0129 6.6112 14.2434 7.14092C14.7141 7.3435 15.2003 7.50805 15.6972 7.63298C15.8597 7.67385 15.9739 7.81957 15.9739 7.98695C15.9739 8.15434 15.8597 8.30031 15.697 8.34117C15.2001 8.46604 14.714 8.63059 14.2434 8.83323C13.0127 9.36295 11.9358 10.0898 11.0127 11.0127C10.0898 11.936 9.36295 13.0129 8.83323 14.2434C8.63056 14.7141 8.46593 15.2003 8.34092 15.6972C8.32114 15.7762 8.27558 15.8463 8.21146 15.8964C8.14734 15.9465 8.06833 15.9738 7.98695 15.9739C7.81957 15.9739 7.67385 15.8597 7.63298 15.697C7.50802 15.2001 7.34339 14.714 7.14068 14.2434C6.6112 13.0127 5.88455 11.9358 4.96123 11.0127C4.03815 10.0898 2.96123 9.36295 1.73046 8.83323C1.25987 8.63058 0.773805 8.46595 0.276923 8.34092C0.197979 8.3212 0.127873 8.27569 0.077712 8.21162C0.0275511 8.14755 0.00020297 8.06857 0 7.9872C0 7.81982 0.114462 7.67409 0.276923 7.63323C0.773826 7.50828 1.2599 7.34365 1.73046 7.14092C2.96123 6.61145 4.0384 5.88455 4.96123 4.96148C5.88431 4.03865 6.6112 2.96148 7.14092 1.73071C7.3435 1.26011 7.50804 0.774045 7.63298 0.277169C7.65267 0.198138 7.69819 0.127947 7.76232 0.0777335C7.82645 0.0275203 7.90551 0.000161972 7.98695 0Z",
				fill: "url(#paint0_linear_9544_298)"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_9544_298)",
			children: [
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter0_f_9544_298)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M-1.44231 12.4853C0.403352 13.1408 2.52471 11.9117 3.29591 9.74015C4.06711 7.56883 3.19597 5.27714 1.35031 4.62163C-0.495356 3.96612 -2.61671 5.19517 -3.38816 7.36649C-4.15911 9.53806 -3.28797 11.8298 -1.44231 12.4853Z",
						fill: "#FFE432"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter1_f_9544_298)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M6.75264 5.32578C9.28803 5.32578 11.3437 3.22485 11.3437 0.633591C11.3437 -1.95792 9.28827 -4.05859 6.75264 -4.05859C4.21701 -4.05859 2.16113 -1.95767 2.16113 0.633591C2.16113 3.22485 4.21676 5.32578 6.75264 5.32578Z",
						fill: "#FC413D"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter2_f_9544_298)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M4.9682 20.3319C7.61509 20.2027 9.62494 17.318 9.4573 13.8891C9.28992 10.4601 7.00807 7.78519 4.36118 7.91467C1.71429 8.04414 -0.295558 10.9286 -0.127927 14.3575C0.0397038 17.7864 2.3213 20.4614 4.9682 20.3319Z",
						fill: "#00B95C"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter3_f_9544_298)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M4.9682 20.3319C7.61509 20.2027 9.62494 17.318 9.4573 13.8891C9.28992 10.4601 7.00807 7.78519 4.36118 7.91467C1.71429 8.04414 -0.295558 10.9286 -0.127927 14.3575C0.0397038 17.7864 2.3213 20.4614 4.9682 20.3319Z",
						fill: "#00B95C"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter4_f_9544_298)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M7.61922 18.2594C9.83805 16.9092 10.432 13.8345 8.94574 11.3917C7.45947 8.94861 4.45565 8.0627 2.23658 9.41261C0.0174985 10.763 -0.576471 13.8377 0.909806 16.2808C2.39658 18.7236 5.40014 19.6095 7.61922 18.2594Z",
						fill: "#00B95C"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter5_f_9544_298)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M16.5887 10.5802C19.0827 10.5802 21.1046 8.63309 21.1046 6.23161C21.1046 3.82989 19.0827 1.88281 16.5887 1.88281C14.0947 1.88281 12.0728 3.82989 12.0728 6.23161C12.0728 8.63334 14.0947 10.5802 16.5887 10.5802Z",
						fill: "#3186FF"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter6_f_9544_298)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M-3.21605 10.0784C-0.919437 11.8246 2.43539 11.2769 4.27736 8.85454C6.11933 6.43239 5.75109 3.05294 3.45447 1.30673C1.15786 -0.439734 -2.19673 0.107958 -4.03894 2.53036C-5.88091 4.95251 -5.51242 8.3322 -3.21605 10.0784Z",
						fill: "#FBBC04"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter7_f_9544_298)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M8.55108 12.6602C11.292 14.5447 14.9255 14.0199 16.6663 11.4875C18.4073 8.95532 17.5965 5.37501 14.8553 3.49046C12.1142 1.60541 8.48093 2.1307 6.73988 4.66264C4.99908 7.19507 5.80967 10.7754 8.55084 12.6602H8.55108Z",
						fill: "#3186FF"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter8_f_9544_298)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M13.5344 -0.577923C14.2318 0.370261 13.3356 2.21346 11.533 3.53949C9.73014 4.86552 7.70355 5.17174 7.0062 4.2238C6.30884 3.27537 7.20484 1.43192 9.00743 0.106138C10.8103 -1.21989 12.8371 -1.52611 13.5342 -0.578169L13.5344 -0.577923Z",
						fill: "#749BFF"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter9_f_9544_298)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M7.8095 3.96262C10.5974 1.37652 11.5542 -2.12477 9.94685 -3.85769C8.33947 -5.59061 4.77615 -4.89941 1.98821 -2.31332C-0.799731 0.27277 -1.75678 3.77406 -0.149146 5.50699C1.45824 7.23991 5.02156 6.54871 7.8095 3.96262Z",
						fill: "#FC413D"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter10_f_9544_298)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M2.09456 13.2499C3.75167 14.4359 5.65395 14.6161 6.34367 13.6526C7.03339 12.6889 6.24915 10.9464 4.59204 9.76044C2.93518 8.57447 1.03266 8.39429 0.343179 9.35773C-0.346544 10.3214 0.437456 12.064 2.09456 13.2499Z",
						fill: "#FFEE48"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_9544_298",
				x: -4.88002,
				y: 3.23424,
				width: 9.66776,
				height: 10.637,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: .605538,
						result: "effect1_foregroundBlur_9544_298"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_f_9544_298",
				x: -3.6929,
				y: -9.91262,
				width: 20.8907,
				height: 21.0909,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 2.92702,
						result: "effect1_foregroundBlur_9544_298"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_f_9544_298",
				x: -5.11443,
				y: 2.93342,
				width: 19.5585,
				height: 22.3793,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 2.48837,
						result: "effect1_foregroundBlur_9544_298"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_f_9544_298",
				x: -5.11443,
				y: 2.93342,
				width: 19.5585,
				height: 22.3793,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 2.48837,
						result: "effect1_foregroundBlur_9544_298"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter4_f_9544_298",
				x: -4.88543,
				y: 3.80451,
				width: 19.6263,
				height: 20.0629,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 2.48837,
						result: "effect1_foregroundBlur_9544_298"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter5_f_9544_298",
				x: 7.34365,
				y: -2.8463,
				width: 18.49,
				height: 18.1574,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 2.36455,
						result: "effect1_foregroundBlur_9544_298"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter6_f_9544_298",
				x: -9.49746,
				y: -4.00087,
				width: 19.2332,
				height: 19.3885,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 2.14302,
						result: "effect1_foregroundBlur_9544_298"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter7_f_9544_298",
				x: 1.99506,
				y: -1.46832,
				width: 19.4161,
				height: 19.089,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 1.91385,
						result: "effect1_foregroundBlur_9544_298"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter8_f_9544_298",
				x: 3.34455,
				y: -4.55389,
				width: 13.8514,
				height: 12.7523,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 1.71249,
						result: "effect1_foregroundBlur_9544_298"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter9_f_9544_298",
				x: -3.822,
				y: -7.7053,
				width: 17.4414,
				height: 17.059,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 1.4464,
						result: "effect1_foregroundBlur_9544_298"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter10_f_9544_298",
				x: -3.48778,
				y: 5.15773,
				width: 13.6626,
				height: 12.6963,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 1.79028,
						result: "effect1_foregroundBlur_9544_298"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_9544_298",
				x1: 4.5408,
				y1: 10.688,
				x2: 12.8377,
				y2: 3.69329,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#4893FC" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .27,
						stopColor: "#4893FC"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .777,
						stopColor: "#969DFF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#BD99FE"
					})
				]
			})
		] })
	]
});
export default SvgGemini;
